import { render, staticRenderFns } from "./LightspeedError.vue?vue&type=template&id=fcee4fb2"
import script from "./LightspeedError.vue?vue&type=script&lang=ts"
export * from "./LightspeedError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports